
import { useSearchParams } from 'react-router-dom';
import AdminTabs from '@/components/admin/AdminTabs';
import { AdminPageHeader } from '@/components/admin/AdminPageHeader';

const AdminPanel = () => {
  const [searchParams] = useSearchParams();
  
  // Get the tab from URL query params
  const defaultTab = searchParams.get('tab') || 'dashboard';

  return (
    <div className="container mx-auto px-4 lg:px-8 max-w-7xl">
      <div className="py-6 space-y-6 lg:py-8">
        <AdminPageHeader
          title="System Admin"
          description="Manage platform-wide settings, users, and system configuration"
          showOrganizationInfo={false}
        />
        
        <AdminTabs defaultTab={defaultTab} />
      </div>
    </div>
  );
};

export default AdminPanel;
